import { isEdgeChromium, isWindows } from 'react-device-detect';

import useFormat from '../../../../hooks/useFormat';
import ExternalApplicationItem from '../components/ExternalApplicationItem';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';

type SilaeSpecificType = {
	instance: string;
};

const Silae = ({ name }: ExternalApplicationType) => {
	const { isMobileFormat } = useFormat();

	const isSilaeAvailable = isEdgeChromium && isWindows;

	const disabledMessage = isMobileFormat
		? 'Silae est indisponible sur mobile.'
		: "Vous ne pouvez accéder à Silae qu'avec un ordinateur Windows et un navigateur Microsoft Edge Chromium.";

	return (
		<ExternalApplicationItem
			name={name}
			imageSrc="/widgets/images/silae-logo.png"
			disabled={!isSilaeAvailable}
			disabledMessage={disabledMessage}
		/>
	);
};

export const getDetails = ({
	name,
	specific,
}: Pick<ExternalApplicationType, 'name' | 'specific'>): ExternalApplicationDetails => {
	const jsonSpecific = specific ? (JSON.parse(specific) as SilaeSpecificType) : undefined;
	const { instance } = jsonSpecific ?? {};

	if (!instance) {
		throw new Error('The Silae app instance is missing.');
	}

	return {
		name,
		url: `https://${instance}.silae.fr/debut.aspx`,
		component: <Silae name={name} specific={specific} />,
		isDisabled: !isEdgeChromium || !isWindows,
	};
};
